module.exports = __webpack_public_path__ + "static/media/timelapse45.db30ca4f.mp4";